export default {
  sale_enable_time_spec: 'Date and time specification',
  sale_start_time: 'Start time',
  sale_start_time_now: 'After approval',
  sale_start_time_set: 'Set date',
  sale_close_time: 'Close time',
  sale_close_time_manual: 'Allow to manual close',
  sale_soft_cap_with_asset: 'Soft cap (%{asset})',
  sale_soft_cap: 'Soft cap',
  sale_hard_cap_with_asset: 'Hard cap (%{asset})',
  sale_hard_cap: 'Hard cap',
  sale_base_asset_for_hard_cap: 'Base asset for hard cap',
  sale_base_asset_hard_cap_to_sell: '%{asset} to sell',
  sale_provide_information: 'Provide fund information',
  sale_description_step: 'Description',
  sale_next_step: 'Next step',
  sale_short_blurb: 'Short blurb',
  sale_description_label: 'Description (under 250 symbols)',
  sale_full_description: 'Full description',
  sale_tell_about_fund: 'Tell people about your fund',
  sale_project_information: 'Enter Information about the project',
  sale_create_sale: 'Create fund',
  sale_in_process_of_creation: 'In process of creation',
  sale_open_requests: 'Fund open requests',
  sale_start_new_sale: 'Start new fund',
  sale_quote_assets: 'Accept investments in:',
  sale_confirm: 'Please confirm a fund creation',
  sale_get_asset: 'In %{asset}',
  sale_invest_asset: 'Invest %{asset}',
  sale_offer_created: 'Invested successfully. Your account will be funded with %{asset} once the fund succeed',
  sale_offer_cancelled: 'Your %{asset}\'s investment cancelled successfully.',
  sale_offer_cancel: 'Cancel offer',
  sale_offer_cancel_tip: 'Current invested amount: %{amount} %{asset}',
  sale_token_sale_agreement: 'View Token Fund Agreement',
  sale_by_owner: 'by %{owner}',
  sale_invest: 'Invest',
  sale_investing: 'Investing',
  sale_tip: 'Tokens will only be issued if the funding target is reached by %{endTime}',
  sale_corporate_details: 'Corporate details',
  sale_crowdfund_team: 'Crowdfund team',
  sale_crowdfund_leader: 'Crowdfund leader',
  sale_accept_investments: 'Please select asset(s) in which you will accept investments',
  sale_disable_invest_owners: 'Owners of the fund can\'t invest themselves',
  sale_disable_invest_hardcap_exceed: 'Investing amount has exceeded hard cap: %{amount}',
  sale_disable_invest_upcoming_sale: 'Upcoming funds are not investable',
  sale_disable_invest_closed_sale: 'Closed funds are not investable',
  sale_disable_invest_canceled_sale: 'Canceled funds are not investable',
  sale_state: 'Fund state',
  sale_not_available_exp: 'Fund creation is available only for corporate users, complete verification to become one.',
  sale_nothing_found: 'Nothing found',
  sale_no_created_sales: 'You have not created any sales yet.',
  sale_create_request_success: 'Information uploaded. Now please wait for approval',
  sale_offer_overlap: 'Creation of new offer will update the old one',
  sale_max_invest: 'Set maximum investable amount',
  sale_creation_requests: 'Fund creation requests',
  sale_no_creation_requests: 'No fund creation requests',
  sale_no_creation_requests_desc: 'Here will be the list of your fund creation requests',
  sale_short_description: 'Short description',
  sale_fund_video: 'Video about fund',
  sale_investments: 'Investments',
  sale_investment_history: 'Investment history',
  sale_company_status_active: 'Active',
  sale_company_status_completed: 'Completed',
  sale_company_info: 'Information about company',
  sale_collected: 'Collected',
  sale_purpose_collection: 'Purpose of collection',
  sale_remains_to_collect: 'Remains to collect',
  sale_until_the_end: 'Until the end campaign',
  sale_campaign_type: 'Campaign type',
  sale_sales_share: 'Sales share',
  sale_profitability: 'Profitability',
  sale_fixed_annual_arrive: 'Fixed annual arrive',
  sale_campaign_duration: 'Campaign duration',
  sale_minimum_investment: 'Minimum investment',
  sale_confirm_upload_ttl: 'Important',
  sale_confirm_upload: 'Please ensure your document is up to date and valid. It will be publicly visible and can be downloaded by anyone. Documents can be deleted if required.',
  sale_upload_success: 'Document uploaded successfully',
  sale_doc_tab_title_is_my: 'Valid legal documents allow investors to build trust in your corporate',
  sale_doc_tab_docs_is_my: 'Uploaded documents will be listed here',
  sale_upd_tab_add_update: 'Add update to the timeline',
  sale_upd_tab_add_timeline: 'Add item to timeline',
  sale_upd_tab_share_updates: 'Share your updates with your backers and potential investors!',
  sale_upd_tab_important_updated: 'Important updates will be posted here',
  sale_upd_tab_warning: 'You won\'t be able to edit or delete update later',
  sale_new_update: 'New Update',
  sale_investor_income: 'Investor income',
  sale_project_name: 'Investment project',
  sale_limit_exceeded: 'Limit exceeded',
  sale_investment_project_name: 'Investment project name',
  sale_tab_overview: 'Overview',
  sale_tab_details: 'Details',
  sale_tab_token: 'Token',
  sale_tab_video: 'Video',
  sale_tab_updates: 'Updates',
  sale_tab_documents: 'Documents',
  sale_tab_dividends: 'Dividends',
  sale_pay_dividends: 'Pay dividends',
  sale_payout_amount: 'Payout amount',
  sale_token_holder: 'Token holder',
  sale_balance: 'Balance',
  sale_dividends: 'Dividends',
  sale_dividends_confirm_title: 'Pay dividends?',
  sale_dividends_confirm_text: 'Confirm the transfer of dividend payments to the selected recipients, for the total amount of %{amount} EUR. The payout is sent to the campaign card.',
  sale_dividends_confirm_bt_confirm: 'Confirm',
  sale_dividends_confirm_bt_cancel: 'Cancel',
  sale_dividends_search_placeholder: 'Search by email...',
  sale_type_fund: 'Fund type',
  sale_publication: 'Publication',
  sale_choose_fund_type: 'Choose Fund type',
  sale_choose_fund_subtype: 'Investment subtype',
  sale_type_crowdinvesting: 'Crowdinvesting',
  sale_type_crowdfunding: 'Crowdfunding',
  sale_type_description: 'Select this type if you are willing to rise funds',
  sale_type_description_investing: 'You have a serious project that requires additional investments for development',
  sale_subtype_description: 'Investors get their investment back + fixed annual percentage. Payments do not depend on your profit',
  sale_subtype_description_equity: 'The classic investment system, where the amount of dividends depends on your income',
  sale_progress_value: 'Filled at %{progress}%',
  sale_subtype_deposit: 'Loan',
  sale_subtype_equity: 'Equity',
  sale_subtype_crowdfunding: 'Crowdfunding',
  sale_year_earn: 'Fixed annual profit',
  sale_payout_frequency: 'Frequency of payments',
  sale_payout_frequency_divid: 'Frequency of dividend payments',
  sale_loan_term: 'Campaign term, month',
  sale_equity_reporting: 'Frequency of submission of financial statements',
  sale_start: 'Start',
  sale_finish: 'Finish',
  sale_term_control: 'Срок управления активом',
  sale_term_control_description: 'После начала срока инвесторы имеют право требовать у вас возвращения тела инвестиции.',
  sale_term_control_description_2: 'В конце срока вы обязаны вернуть тело инвестиции всем инвесторам.',
  sale_early_exit: 'Условия раннего выхода — ставка дисконтирования',
  sale_additional_recipient: 'Список дополнительных получателей дивидендов',
  sale_recipient_email: 'Почта получателя',
  sale_deduction_percentage: 'Процент отчисления',
  sale_add_more_recipient: 'Добавить ещё',
  sale_campaign_settings: 'Project settings',
  sale_your_fund_type: 'Type of your project',
  sale_campaign_start: 'Project start',
  sale_campaign_finish: 'Project finish',
  sale_campaign_time_description: 'We suggest set the project period at least 2-3 weeks - in this way more investors will see it',
  sale_investment_asset: 'Investment collection currency',
  sale_softcap_description: 'Soft cap is the minimum investment threshold that your project must reach.',
  sale_hardcap_description: 'Hard cap is the maximum investment threshold. When it is reached, the project is closed automatically.',
  sale_collection_amount: 'Ammount to collect',
  sale_available_currencies: 'Available currencies for investment',
  sale_available_currencies_description: 'Here you choose in which currency investors will be able to invest in your project.',
  sale_available_currencies_description_2: 'We automatically convert the investment amount. For example, if you set USD as the collection currency, and the investor wants to invest using EUR, the System converts his investment into USD based on the current exchange rate.',
  sale_create_token: 'Asset creation',
  sale_token_logo_title: 'Asset logotype',
  sale_name_token_title: 'Enter asset name',
  sale_my_token: 'My asset',
  sale_token_code_title: 'Enter unique asset code',
  sale_token_code_description: '— from 3 to 5 symbols',
  sale_token_code_description_2: ' — only Latin and numbers',
  sale_token_for_sale: 'Amount of assets for sale',
  sale_campaign_name: 'Enter name of your project',
  sale_campaign_name_label: 'My project',
  sale_campaign_preview: 'Project preview',
  sale_campaign_description: 'Project description',
  sale_add_video: 'Add a video about the project',
  sale_add_video_label: 'YouTube link',
  sale_add_button: 'Download file',
  sale_publication_text_1: 'Your project is ready for publication, we just need to check it.',
  sale_publication_text_2: 'You can go back to any step and check the entered data.',
  sale_publication_text_3: 'When the project is approved, you will not be able to change the data. Therefore, we suggest check everything.',
  sale_publication_confirm: 'Send for check',
  sale_crowdfunding: 'Crowdfunding',
  sale_crowdinvesting: 'Crowdinvesting',
  sale_deposit: 'Crowdinvesting - Loan',
  sale_equity: 'Crowdinvesting - Equity',
  sale_video_title: 'Add a link to the video that will be a preview of your project',
  sale_video_preview_error: 'Incorrect video link',
  sale_video_formats: 'Supported services: YouTube',
  sale_video_past: 'Paste the link here',
  sale_publication_btn: 'Publish my project',
  sale_period_month: 'Month',
  sale_period_quarter: 'Quarter',
  sale_period_half_year: 'Half-year',
  sale_period_year: 'Year',
  sale_status_title: 'Great! We are already checking your project.',
  sale_status_text_accent: 'Вы можете отслеживать статус вашей заявки в разделе «Мои проекты»',
  sale_status_text: 'If you set the start date after approval, the project will be published immediately after confirmation.',
  sale_interest_description: 'Здесь мы объясняем пользователю что значит доходность и от чего зависит процент доходности инвестора',
  sale_interest_from: 'from',
  sale_interest_to: 'to',
  sale_interest_profitability: 'Interest Rate — Profitability',
  sale_to_end: '%{days} days left',
  sale_ends_today: 'Ends today',
  sale_minimum_invest: 'Minimum investment amount',
  sale_set_min_invest: 'Set the minimum amount you want to accept from investors.',
  sale_back_to_list: 'Back',
  sale_add_video_bt: 'Add video',
  sale_add_update_bt: 'Add update',
  sale_upload_document_bt: 'Upload document',
  sale_tab_documents_ismy_header: 'Here will be your documents related to the campaign',
  sale_tab_documents_ismy_text: 'Investors value transparency - share financial statements, development strategy and other important documents with them',
  sale_tab_updates_ismy_header: 'Your notes about the campaign update will be here',
  sale_tab_updates_ismy_text: 'Tell your investors about the news of the campaign - at what stage it is, do you need additional help or just thank them for their participation',
  sale_add_note_bt: 'Add a note',
  sale_video_empty_header: 'A list of uploaded videos will be displayed here',
  sale_invested_header: 'Your investment amount',
  sale_invested_closed_text: 'Closed campaign investments are not accepted',
  sale_invested_amount_text: 'Your investment amount',
  sale_invested_change_amount_bt: 'Change investment amount',
  sale_invested_cancel_bt: 'Cancel investment',
  sale_invested_block_header: 'Investment',
  sale_invested_your_balance: 'Your balance',
  sale_invested_your_profit: 'Your profit will be',
  sale_invested_is_upcoming: 'Campaigns that have not started are not eligible for investment',
  sale_invested_hard_cap_exceeded: 'The amount of investments has reached the maximum threshold',
  sale_invested_is_closed: 'Private campaigns are not eligible for investment',
  sale_invested_is_canceled: 'Private campaigns are not eligible for investment',
  sale_invested_limit_exceeded: 'Limit is exceeded',
  sale_profit_from_to: 'from %{from} to %{to}',
  sale_updates_header: 'Header',
  sale_update_news: 'News summary',
  sale_updates_textarea_label: 'Text',
  sale_updates_textarea_placeholder: 'Tell us more about your achievements or campaign news',
  sale_updates_add_note_bt: 'Add a note',
  sale_updates_add_note_text: 'Published posts cannot be edited or deleted - check everything before publishing',
  sale_updates_empty_header: 'Have news about the campaign?',
  sale_updates_empty_text: 'Share them with investors',
  sale_token_created: 'Asset has already been created and confirmed by Administrator. You can not edit or change it'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/sale_view.js